<template>
  <div class="onepage" v-scroll-spy="{allowNoActive: true}">
    <onepage-landing id="start" class="onepage__section" :general=" general "></onepage-landing>
    <onepage-news id="aktuelles" class="onepage__section"></onepage-news>
    <onepage-about id="ueber-uns" class="onepage__section">
      <template slot="append"><div class="onepage__fixed-image"></div></template>
    </onepage-about>
    <onepage-events id="termine" class="onepage__section"></onepage-events>
    <onepage-join id="mitglied-werden" class="onepage__section"></onepage-join>
    <onepage-contact id="kontakt" class="onepage__section"></onepage-contact>
  </div>
</template>

<script>
  import OnepageLanding from '@/views/onepage/landing'
  import OnepageNews from '@/views/onepage/news'
  import OnepageEvents from '@/views/onepage/events'
  import OnepageAbout from '@/views/onepage/about'
  import OnepageJoin from '@/views/onepage/join'
  import OnepageContact from '@/views/onepage/contact'

  export default {
    id: 'Landing',
    props: ['general'],
    components: {
      OnepageLanding,
      OnepageNews,
      OnepageEvents,
      OnepageAbout,
      OnepageJoin,
      OnepageContact
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .onepage {
    &__section {
      padding: 6rem 0;
    }

    // needed to move this inside an section for scrollwatch fo behave properly
    &__fixed-image {
      margin: 6rem 0 -6rem; // see section padding
      width: 100%;
      height: 66vh;
      background: url(../../assets/backgrounds/bg-fixed-compressor.jpg);
      background-size: cover;
      background-position: center top;
      background-attachment: fixed;
      box-shadow: inset 0 -10px 15px 5px rgba(black, .33), inset 0 10px 15px 5px rgba(black, .33),;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/frame.vue